import React, { useContext, useEffect, useState } from "react";
import studyviewerContext from "../../../../../../context/studyviewer/StudyviewerContext";
import ModalHeader from "../../../../../../components/Modal/ModalHeader";
import { Modal } from "@fluentui/react";
import ModalFooter from "../../../../../../components/Modal/ModalFooter";
import { useTranslation } from "react-i18next";
import ManageKeyImageRow from "./ManageKeyImageRow";
import ModalMain from "../../../../../../components/Modal/ModalMain";
import themeContext from "../../../../../../context/theme/ThemeContext";

const ManageKeyImageModal = (props) => {
  const { patientResponseData, keyImages, setKeyImages } =
    useContext(studyviewerContext);
  const { t } = useTranslation();
  const { getAlterColor } = useContext(themeContext);
  const [savedKeyImages, setSavedKeyImages] = useState([]);
  const [unsavedKeyImages, setUnsavedKeyImages] = useState([]);

  useEffect(() => {
    let savedImages = keyImages.filter((keyImage) => {
      if (keyImage.state === "SAVED") return keyImage;
    });
    let unsavedImages = keyImages.filter((keyImage) => {
      if (keyImage.state !== "SAVED" && keyImage.state !== "DELETED")
        return keyImage;
    });

    setSavedKeyImages(savedImages);
    setUnsavedKeyImages(unsavedImages);

    console.log(savedKeyImages);
    console.log(unsavedKeyImages);
  }, keyImages);


  const modalDetails = {
    header: (
      <ModalHeader
      handleCancel={() => props.setShowManageKeyImageModal(false)}
      patientName={patientResponseData?.patientName}
      patientID={patientResponseData?.patientId}
      updatedModal = {true}
      heading = "Manage Key Images"
    />
    ),
    body:  <div style={{ padding: "15px 0" }}>
    {savedKeyImages.length > 0 || unsavedKeyImages.length > 0 ? (
      <>
        <div>
          {savedKeyImages.length > 0 && (
            <>
              <span
                style={{
                  marginLeft: "15px",
                  fontSize: "16px",
                  fontWeight: "bold",
                  color: getAlterColor("#FFFFFF","#000"),
                }}
              >
                Saved Images
              </span>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {savedKeyImages?.map((keyImage,index) => {
                  return (
                    <React.Fragment key={index}>
                      <ManageKeyImageRow
                        keyImage={keyImage}
                        setShowDialogBox={props.setShowDialogBox}
                        setDialogMessage={props.setDialogMessage}
                      />
                    </React.Fragment>
                  );
                })}
              </div>
            </>
          )}
        </div>
        <div
          style={{
            marginTop: "15px",
          }}
        >
          {unsavedKeyImages.length > 0 && (
            <>
              <span
                style={{
                  marginTop: "20px",
                  marginLeft: "15px",
                  fontSize: "16px",
                  fontWeight: "bold",
                  color: getAlterColor("#FFFFFF","#000"),
                }}
              >
                Unsaved Images
              </span>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {unsavedKeyImages.map((keyImage) => {
                  return (
                    <>
                      <ManageKeyImageRow
                        keyImage={keyImage}
                        setShowDialogBox={props.setShowDialogBox}
                        setDialogMessage={props.setDialogMessage}
                      />
                    </>
                  );
                })}
              </div>
            </>
          )}
        </div>
      </>
    ) : (
      <>
        <div
          style={{
            height: "70px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <span style={{ marginLeft: "20px", color: "#eb1b1b" }}>
            {" "}
            {t("key-image.no-key-images")}
          </span>
        </div>
      </>
    )}
  </div>,
    footer: <ModalFooter PrimaryButtonList={[]} DefaultButtonList={[
      {
        title: t("key-image.cancel"),
        onclick: () => props.setShowManageKeyImageModal(false),
      },
    ]} />,
    width: "500px",
  };



  return (

    <ModalMain
    updatedModal={true}
    modalDetails={modalDetails}
    showModal={true}
    />
  );
};

export default ManageKeyImageModal;
